import { render, staticRenderFns } from "./RemixesPage.vue?vue&type=template&id=323bd96a&"
import script from "./RemixesPage.vue?vue&type=script&lang=js&"
export * from "./RemixesPage.vue?vue&type=script&lang=js&"
import style0 from "./RemixesPage.vue?vue&type=style&index=0&id=323bd96a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports